export default function BtnCoupon($DOM, classes) {
	const $container = $('.btn--coupon');

	if(!$container.length) {
		return false;
	}

	$container.click(function(event) {
		const $this = $(this);

		if(!$this.hasClass(classes.Active)) {
			event.preventDefault();

			$this.addClass(classes.Active);
		}
	});
}